"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const AutocompleteTagWrap = styled_components_1.default.div.attrs({
    'data-id': `tag`,
})(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({}, theme.autocomplete.tagWrap)), ({ theme, active }) => active
    ? (0, util_theme_sxc_1.sx2CssThemeFn)({
        borderColor: theme.colors.accentColor,
    })
    : {});
const RemoveButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    role: 'button',
    variant: 'iconBtn',
    icon: { name: 'close-outlined' },
    'data-id': `remove`,
})(({ theme }) => theme.autocomplete.autocompleteRemoveButtonStyles);
const AutocompleteTag = props => {
    const { label = props.children, active = false, name, onRemove } = props;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const handleRemove = onRemove
        ? (event) => {
            event.stopPropagation();
            onRemove();
        }
        : undefined;
    return (react_1.default.createElement(AutocompleteTagWrap, { active: active },
        label,
        react_1.default.createElement(RemoveButton, { onClick: handleRemove }, t('common:remove', { name }))));
};
exports.default = AutocompleteTag;
//# sourceMappingURL=AutocompleteTag.js.map